module.exports = __webpack_public_path__ + "media/customizations/fieldslife/logo-new-2f919a2a039682b8a62252f5c6d15376.png";